/**
 * @项目名称: work
 * @功能名称:  获取skeyType
 * @文件名称: getSkeyType
 * @Date: 2020/1/15
 * @Author: liux
 * @Copyright（C）2020 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

import getBrowserInfo from 'bjxy-common/helper/getBrowserInfo';
import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'
const ua = getBrowserInfo();
const type = ua.isPc ? '_PC' : ua.weixin ? '_WEIXIN' : '_MOBILE';

const findPassword = function(productType) {
  let product_id = 104
  switch(productType){
    case 15:
      product_id = 101
      break;
    case 11:
      product_id = 102
      break;
    case 17:
      product_id = 103
      break;
    case 22:
      product_id = 105
      break;
    default:
      break
  }
  const redirect_url = encodeURIComponent(location.href)
  return replaceDomain(`https://account.xiaoying.com/loginPassword/find?channel_id=KADAI${type}&redirect_url=${redirect_url}&product_id=${product_id}`)
}
export default  {
  findPassword,
  skeyType: 'KADAI'+type
}
